import { BannerId } from '../../typings/banners';
import { ValidationErrorData } from '../../typings/common';

export const UPDATE_PROMO_CONTENT_URL = 'UPDATE_PROMO_CONTENT_URL';
export type UPDATE_PROMO_CONTENT_URL = typeof UPDATE_PROMO_CONTENT_URL;
export interface UpdatePromoContentUrl {
    type: UPDATE_PROMO_CONTENT_URL;
    bannerId: BannerId;
    urlValue: string;
}
export function updatePromoContentUrl(bannerId: BannerId, urlValue: string): UpdatePromoContentUrl {
    return {
        type: UPDATE_PROMO_CONTENT_URL,
        bannerId,
        urlValue
    };
}

export const PROMO_CONTENT_URL_SHOW_ERRORS = 'PROMO_CONTENT_URL_SHOW_ERRORS';
export type PROMO_CONTENT_URL_SHOW_ERRORS = typeof PROMO_CONTENT_URL_SHOW_ERRORS;
export interface PromoContentUrlShowErrors {
    type: PROMO_CONTENT_URL_SHOW_ERRORS;
    bannerId: BannerId;
    errors: ValidationErrorData[];
}
export function promoContentUrlShowErrors(
    bannerId: BannerId,
    errors: ValidationErrorData[]
): PromoContentUrlShowErrors {
    return {
        type: PROMO_CONTENT_URL_SHOW_ERRORS,
        bannerId,
        errors
    };
}

export const UPDATE_PROMO_CONTENT_ID = 'UPDATE_PROMO_CONTENT_ID';
export type UPDATE_PROMO_CONTENT_ID = typeof UPDATE_PROMO_CONTENT_ID;
export interface UpdatePromoContentId {
    type: UPDATE_PROMO_CONTENT_ID;
    bannerId: BannerId;
    contentId: string;
}
export function updatePromoContentId(bannerId: BannerId, contentId: string): UpdatePromoContentId {
    return {
        type: UPDATE_PROMO_CONTENT_ID,
        bannerId,
        contentId
    };
}

export const UPDATE_PROMO_CONTENT_PREVIEW_URL = 'UPDATE_PROMO_CONTENT_PREVIEW_URL';
export type UPDATE_PROMO_CONTENT_PREVIEW_URL = typeof UPDATE_PROMO_CONTENT_PREVIEW_URL;
export interface UpdatePromoContentPreviewUrl {
    type: UPDATE_PROMO_CONTENT_PREVIEW_URL;
    bannerId: BannerId;
    previewUrl: string;
}
export function updatePromoContentPreviewUrl(bannerId: BannerId, previewUrl: string): UpdatePromoContentPreviewUrl {
    return {
        type: UPDATE_PROMO_CONTENT_PREVIEW_URL,
        bannerId,
        previewUrl
    };
}

export type BannerContentPromotionAction =
    | UpdatePromoContentUrl
    | UpdatePromoContentId
    | PromoContentUrlShowErrors
    | UpdatePromoContentPreviewUrl;
